
/**
 * Define el modelo de los términos
 *
 * *Defines the Terms Model*
 *
 * @type {class}
 */
export class TermsModel {

  /**
   * Inicializaión de la variable termsIdentity como any
   *
   * *Set termsIdentity variable as any*
   *
   * @access              public
   * @type                {any}
   */
  termsIdentity: any;

  /**
   * Inicializaión de la variable termsConfirmation como any
   *
   * *Set termsConfirmation variable as any*
   *
   * @access              public
   * @type                {any}
   */
  termsConfirmation: any;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * @var {Object} termsIdentity Sets object attributes
   * @var {Object} termsIdentity  Sets object attributes.
   */
  constructor() {
    this.termsIdentity = {
      text: '',
      title: '',
      terms_id: '',
    };
    this.termsConfirmation = {
      text: '',
      uri: '',
      title: '',
      terms_id: '',
    };
  }
}
